import { logUtil } from 'packages/src'

const setTitleDomUtil = title => {
  logUtil('setTitleDomUtil').debug('title=', title)
  window.document.title = title
}

export default setTitleDomUtil
